<template>
  <v-container>
    <div class="box mt-10">
      <h1 class="h1">Thời gian & Địa điểm</h1>
      <v-row>
        <v-col cols="12" lg="3" sm="6">
          <v-card elevation="2" class="card">
            <div class="title">Thứ Bảy, 14.11.2020</div>
            <div class="content">
              <div class="time">08:45 - 17:00</div>
              <div class="place">Trường Đại học Khoa học Tự nhiên, ĐHQGHN</div>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" lg="3" sm="6">
          <v-card elevation="2" class="card">
            <div class="title">Chủ Nhật, 15.11.2020</div>
            <div class="content">
              <div class="time">08:45 - 17:00</div>
              <div class="place">Trường Đại học Khoa học Tự nhiên, ĐHQGHN</div>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" lg="3" sm="6">
          <v-card elevation="2" class="card">
            <div class="title">Thứ Hai, 16.11.2020</div>
            <div class="content">
              <div class="time">16:30 - 19:45</div>
              <div class="place">Trường Đại học Khoa học Tự nhiên, ĐHQGHN</div>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" lg="3" sm="6">
          <v-card elevation="2" class="card">
            <div class="title">Thứ Ba, 17.11.2020</div>
            <div class="content">
              <div class="time">16:30 - 19:45</div>
              <div class="place">Trường Đại học Khoa học Tự nhiên, ĐHQGHN</div>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" lg="3" sm="6">
          <v-card elevation="2" class="card">
            <div class="title">Thứ Bảy, 21.11.2020</div>
            <div class="content">
              <div class="time">08:45 - 17:00</div>
              <div class="place">Nhà khách Đại học Quốc gia Hà Nội, Ba Vì</div>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" lg="3" sm="6">
          <v-card elevation="2" class="card">
            <div class="title">Chủ Nhật, 22.11.2020</div>
            <div class="content">
              <div class="time">08:45 - 17:00</div>
              <div class="place">Nhà khách Đại học Quốc gia Hà Nội, Ba Vì</div>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <h1 class="h1 mt-5">Vị trí</h1>
      <v-row class="justify-space-between">
        <v-col cols="12" lg="6">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14899.67715690811!2d105.8079772!3d20.9958722!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xd740a66998e1a0ed!2sVNU%20University%20of%20Science!5e0!3m2!1sen!2s!4v1604556423267!5m2!1sen!2s"
            width="100%"
            height="450"
            frameborder="0"
            style="border: 0; display: block"
            allowfullscreen=""
            aria-hidden="false"
            tabindex="0"
          ></iframe>
        </v-col>
        <v-col cols="12" lg="6">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3722.3850247891046!2d105.40020721428866!3d21.097210690815253!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3134607e6a657795%3A0xe7a64b646337a0fe!2zTmjDoCBLaMOhY2ggxJBIUUdITiBCYSBWw6w!5e0!3m2!1sen!2s!4v1604556597272!5m2!1sen!2s"
            width="100%"
            height="450"
            frameborder="0"
            style="border: 0; display: block"
            allowfullscreen=""
            aria-hidden="false"
            tabindex="0"
          ></iframe>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.card {
  border: 3px solid rgb(5, 133, 5);
  text-align: center;
  font-size: 1.5rem;
  font-weight: bold;
  .title {
    padding: 2rem 0;
    font-size: 1.7rem;
    background: rgb(23, 211, 33);
    color: white;
    @media (max-width: 500px) {
      padding: 0.5rem;
      font-size: 1.3rem;
    }
  }
  .content {
    padding: 3rem 2rem;
    .time {
      color: blue;
      font-size: 1.7rem;
    }
    @media (max-width: 500px) {
      padding: 1rem;
      font-size: 1.3rem;
    }
    .place {
      color: black;
    }
  }
}
.h1 {
  margin-left: -1rem;
  @media (max-width: 500px) {
    margin-left: 0rem;
    font-size: 1.3rem;
  }
}
.box {
  background: white;
  padding: 2rem;
  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2),
    0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12) !important;
  border-radius: 4px;
  @media (max-width: 460px) {
    margin-top: 0px !important;
    margin-bottom: 0px !important;
    padding-top: 10px;
    padding-left: 10px;
    padding-right: 10px;
  }
}
</style>